module.exports = __webpack_public_path__ + "static/media/Illus-PlateFull.e6c9a561.png";